import React from 'react';

import { CodeOutlined, LinkOutlined as InsertLinkIcon } from '@ant-design/icons';
import { Button, Tooltip, Typography } from 'antd';

import type IProduct from 'interfaces/IProduct';
import type { ICheckoutsUrls } from 'scenes/Producer/MyCampaigns';
import { CHECKOUT_ELEMENTS_URL, CHECKOUT_SUN_URL } from 'settings';
import PermissionHide from 'v2/components/Shared/PermissionHide';

interface IProps {
  currentProduct: IProduct;
  openUrlCreatorCheckout: (urls: ICheckoutsUrls) => void;
  openTrackerForm: () => void;
}

const AdvancedConfigsUrls = ({ currentProduct, openUrlCreatorCheckout, openTrackerForm }: IProps) => {
  const productId = currentProduct.hash ?? currentProduct.id;

  return (
    <div className='flex flex-col'>
      <Typography.Text className='mb-2 text-[1.25rem] text-black'>Configurações Avançadas</Typography.Text>
      <div className='flex gap-2 max-sm:flex-col max-sm:gap-4'>
        <PermissionHide action='myeduzz:links:editar'>
          <div>
            <Button
              onClick={() => {
                openUrlCreatorCheckout({
                  linkSun: `${CHECKOUT_SUN_URL}/${productId}`,
                  linkChk: `${CHECKOUT_ELEMENTS_URL}/${productId}`
                });
              }}
              block
              icon={<InsertLinkIcon />}
            >
              Gerador de UTM
            </Button>
          </div>
        </PermissionHide>

        <PermissionHide action='myeduzz:links:editar'>
          <div>
            {currentProduct.can_create_pixel && (
              <Tooltip
                title='O pixel deve ser cadastrado no produto principal'
                open={!!currentProduct.parent_product ? undefined : false}
              >
                <span>
                  <Button
                    disabled={!!currentProduct.parent_product}
                    id='trackCampaignButton'
                    block
                    onClick={openTrackerForm}
                    icon={<CodeOutlined />}
                  >
                    Pixel de Conversão
                  </Button>
                </span>
              </Tooltip>
            )}
          </div>
        </PermissionHide>
      </div>
    </div>
  );
};

export default AdvancedConfigsUrls;
